const RoomService = {
  async saveRoom(formData) {
    try {
      let url = '/api/hospitality/rooms';
      let method = 'POST';
      
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      
      if (formData.identifier !== undefined) {
        url = '/api/hospitality/rooms/' + formData.identifier;
        method = 'PUT';
      }
      const updatedData = {
        ...formData, 
        facilities: formData.facilities ? formData.facilities.map(f => f.value) : [],
        accountIdentifier: accountIdentifier
      }
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newRoom = await response.json();
        console.log('Room has been updated:', newRoom);
      }
    } catch (error) {
      console.log('Error saving Room', error);
    }
  },
  async retrieveAllRoomByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/<your_controller>' + accountIdentifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Room', error);
      throw error;
    }
  },
  async retrieveRoom(identifier) {
    try {
      const response = await fetch('/api/hospitality/rooms/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Room', error);
      throw error;
    }
  },
  async deleteRoom(identifier) {
    try {
      let url = '/api/<your_controller>';
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newRoom = await response.json();
        console.log('Room has been deleted:', newRoom);
      }
    } catch (error) {
      console.log('Error deleting Room', error);
    }
  }
};
export default RoomService;
